import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

export const StyledLabel = styled.label`
  display: block;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('14px')};
  line-height: ${rem('14px')};
  ${mediaqueries.greaterThan('mobile')`
    font-size: ${rem('13px')};
  `};
`;
